// extracted by mini-css-extract-plugin
module.exports = {"error":"error-feature_error__LaPds","icon":"error-feature_icon__2p5Ix"};